import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby-plugin-intl';

import rightWhiteChevron from '../images/right-chevron-white.svg';
import rightBlackChevron from '../images/right-chevron-black.svg';
import { fixPropWarnings } from '../utils/fixPropWarnings';
import type { Breadcrumb } from '../types';

import Container from './Container';

const StyledContainer = styled(Container)``;

const StyledLink = styled(Link)`
  display: block;
`;

interface WrapperProps {
  variant?: string;
}

const Wrapper = styled.ul.withConfig(fixPropWarnings('variant'))<WrapperProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 7px;
  align-items: center;
  padding: 3px 0;

  li {
    position: relative;
    font-weight: 500;
    font-size: 14px;
    padding-right: 30px;
    margin: 0;

    &::after {
      content: '';
      position: absolute;
      background-image: url(${rightWhiteChevron});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 8px;
      height: 15px;
      right: 11px;
      top: 50%;
      transform: translateY(-50%);
      ${({ variant }) => variant === 'white' && css`
        background-image: url(${rightBlackChevron});
      `}
    }

    &:last-child {
      padding-right: 0;
      font-weight: 400;

      &::after {
        background-image: none;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    li {
      margin-bottom: 0;
      font-size: 16px;
    }
  }
`;

export const sanitizeURL = (url: string) => url?.split(' ')?.join('-')?.toLowerCase();

interface BreadCrumbsProps {
  className?: string;
  crumbs: Breadcrumb[];
  variant?: string;
}

const BreadCrumbs = ({ className, crumbs, variant }: BreadCrumbsProps) => {
  if (!crumbs) return null;

  return (
    <StyledContainer>
      <Wrapper className={`no-bullets ${className}`} variant={variant}>
        {crumbs.map(({ linkText, linkUrl }, index) => (
          <li key={linkUrl}>
            {index + 1 < crumbs.length ? (
              <StyledLink
                className="breadcrumb-link remove-svg"
                to={sanitizeURL(linkUrl) || '/'}
              >
                {linkText}
              </StyledLink>
            ) : (
              <p>{linkText}</p>
            )}
          </li>
        ))}
      </Wrapper>
    </StyledContainer>
  );
};

export default BreadCrumbs;
